import CommentsWidgetComponent from './comments-widget.component';
import * as CommentsDrawerActions from '../../drawers/comments/comments-drawer.actions';
import { connect } from 'react-redux';

const mapStateToProps = (state, ownProps) => {
    return ownProps;
};

const mapDispatchToProps = dispatch => {
    return {
    	onClick: () => {
    		dispatch(CommentsDrawerActions.open())
    	}
    }
};

const CommentsWidget = connect(mapStateToProps,mapDispatchToProps)(CommentsWidgetComponent);
export default CommentsWidget;